<template>
	<div class="h-100">
		<div class="container h-100">
			<div class="row h-100 justify-content-center align-items-center">
				<div class="col-lg-6">
					<img
						src="/assets/img/abdom-logo.png"
						class="img-fluid mb-4 mx-auto d-block"
						style="max-width: 300px">
					<div class="card text-center">
						<div class="card-body">
							<form class="form-signin">
								<h1>Reset Password</h1>
								<p class="text-muted">
									Enter new password below.
								</p>
								<div class="clearfix mb-4"></div>
								<div class="form-group">
									<label for="email">Email address</label>
									<input
										id="email"
										type="email"
										class="form-control"
										placeholder="Email address"
										required
										autofocus
										:value="email"
										@input="email = $event.target.value">
								</div>
								<div class="form-group">
									<label for="password">New Password</label>
									<input
										id="password"
										type="password"
										class="form-control"
										placeholder="Password"
										required
										autofocus
										:value="password"
										@input="password = $event.target.value">
								</div>
								<div class="form-group">
									<label for="password_confirmation">Confirm Password</label>
									<input
										id="password_confirmation"
										type="password"
										class="form-control"
										placeholder="Password Confirmation"
										required
										autofocus
										:value="password_confirmation"
										@input="password_confirmation = $event.target.value">
								</div>
								<button
									class="btn btn-lg btn-primary btn-block"
									@click.prevent="submitForm">
									Submit
								</button>
								<div class="clearfix mt-2"></div>
								<div class="text-center text-muted">
									<a href="/login">Login</a>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'ResetPassword',
		components: {},
		props: {
			token: {
				type: String,
				required: true
			}
		},
		data () {
			return {
				email: '',
				password: '',
				password_confirmation: '',
				api_error: ''
			}
		},
		mounted () {
		},
		methods: {
			submitForm: function () {
				this.api_error = '';
				this.$axios.post('/api/reset-password', {
					token: this.token,
					email: this.email,
					password: this.password,
					password_confirmation: this.password_confirmation,
				}).then(() => {
					toastr.success('Success.');
					this.$router.push('/login')
				}).catch(error => {
					this.api_error = error.response.data.message
				})

			}
		}
	}
</script>

<style lang="scss" scoped>
	body {
		background: white;
	}

	label {
		color: #B0BAC9;
		text-transform: uppercase;
		font-size: 0.75em;
	}

	#app .content {
		margin-top: 0 !important;
	}

	.form-signin {
		width: 100%;
		max-width: 330px;
		padding: 15px;
		margin: auto;
	}

	.form-signin .checkbox {
		font-weight: 400;
	}

	.form-signin .form-control {
		position: relative;
		box-sizing: border-box;
		height: auto;
		padding: 10px;
		font-size: 16px;
	}

	.form-signin .form-control:focus {
		z-index: 2;
	}

	.form-signin input[type="email"] {
		margin-bottom: -1px;
		border-bottom-right-radius: 0;
		border-bottom-left-radius: 0;
	}

	.form-signin input[type="password"] {
		margin-bottom: 10px;
		border-top-left-radius: 0;
		border-top-right-radius: 0;
	}
</style>
